import { create } from 'zustand';
import { combine } from 'zustand/middleware';
import { Platform } from 'react-native';
import Constants from 'src/core/utils/Constants';

export const useGlobalStore = create(
	combine(
		{
			init_origin: '',
		},
		(set, get) => {
			const setInitOrigin = (init_origin: string) => {
				set({ init_origin });
			};

			const getGaOriginUrl = ({ url, suffix }: { url: string; suffix?: string }): string => {
				const urlWithGaOrigin = new URL(url);

				if (!urlWithGaOrigin.searchParams.get(Constants.paramsGaOrigin)) {
					urlWithGaOrigin.searchParams.set(Constants.paramsGaOrigin, getGaOrigin(suffix === undefined ? {} : { suffix }));
				}

				return urlWithGaOrigin.toString();
			};

			const getGaOrigin = ({ suffix }: { suffix?: string }): string => {
				const gaOriginPlatform = Platform.OS.replace(Constants.platformIos, Constants.gaOriginPlatformIos).replace(
					Constants.platformAndroid,
					Constants.gaOriginPlatformAndroid,
				);

				let origin = `${Constants.gaOriginPrefix}${gaOriginPlatform}`;
				if (suffix) origin = origin + ` | ${suffix}`;

				return origin;
			};

			return {
				setInitOrigin,
				getGaOriginUrl,
				getGaOrigin,
			};
		},
	),
);
